require('promise-polyfill/lib/polyfill');
require('url-polyfill');
require('whatwg-fetch');
require('current-script-polyfill');
require('core-js/stable');
require('regenerator-runtime/runtime');
